import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, PlusCircle, Users, Settings, Activity, HardDrive } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({ isOpen, onClose }) => {
  const { user } = useAuth();

  const menuItems = [
    { name: 'Dashboard', path: '/dashboard', icon: LayoutDashboard, roles: ['SUPER_ADMIN', 'GENERAL_ADMIN', 'PROJECT_ADMIN', 'VISUALIZER'] },
    { name: 'Novo Projeto', path: '/projects', icon: PlusCircle, roles: ['SUPER_ADMIN', 'GENERAL_ADMIN', 'PROJECT_ADMIN'] },
    { name: 'Utilizadores', path: '/users', icon: Users, roles: ['SUPER_ADMIN', 'GENERAL_ADMIN'] },
    { name: 'Logs', path: '/logs', icon: Activity, roles: ['SUPER_ADMIN'] },
    { name: 'Armazenamento', path: '/storage', icon: HardDrive, roles: ['SUPER_ADMIN'] },
    { name: 'Definições', path: '/settings', icon: Settings, roles: ['SUPER_ADMIN', 'GENERAL_ADMIN', 'PROJECT_ADMIN', 'VISUALIZER'] },
  ];

  const filteredMenu = menuItems.filter(item => item.roles.includes(user?.global_role));

  return (
    <>
      {/* Fundo escurecido atrás do menu, só visível em ecrãs pequenos com o menu aberto -
          tocar fora do menu fecha-o. */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 md:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <aside
        className={`fixed md:static top-0 left-0 h-screen w-64 bg-slate-100 dark:bg-[#0b0f1a] border-r border-slate-200 dark:border-slate-800 flex flex-col pt-20 shrink-0 z-40 transition-transform duration-300 ease-out md:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <nav className="flex-1 px-3 space-y-1 overflow-y-auto custom-scrollbar" onClick={onClose}>
          {filteredMenu.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-4 py-3 rounded-xl font-medium text-sm transition-all ${
                  isActive
                    ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/20'
                    : 'text-slate-600 dark:text-slate-400 hover:bg-slate-200 dark:hover:bg-slate-800'
                }`
              }
            >
              <item.icon size={20} strokeWidth={2} />
              <span>{item.name}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-200 dark:border-slate-800 text-center">
          <p className="text-[10px] font-bold text-slate-400 dark:text-slate-600 uppercase tracking-widest">
            PrintHeritage v1.0
          </p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
